export default "__VITE_ASSET__CklpBl_A__"